import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  AlertModal,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Text,
  Space,
} from '@cashfree-intl/coherent';
import _get from 'lodash/get';

// Constants
import { MODAL_TYPES } from '../constants';

// Componenets
import VerifyModal from './VerifyModal';

const Modals = ({ modalType, setModalType }) => {
  const [details, setDetails] = useState({});
  const handleClose = () => setModalType();

  const handleVerify = (status, data) => {
    setModalType(status);
    setDetails(data);
  };

  switch (modalType) {
    case MODAL_TYPES.VERIFY:
      return <VerifyModal onClose={handleClose} onVerify={handleVerify} />;

    case MODAL_TYPES.SUCCESS:
      return (
        <AlertModal
          type="success"
          title="Liveliness Check Successful"
          onClose={() => handleClose()}
          maxWidth="380"
        >
          <Table basic="very" compact>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Text color="bodyLight">Reference ID</Text>
                </TableCell>
                <TableCell>
                  {_get(details, 'reference_id', '–')}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Text color="bodyLight">Score</Text>
                </TableCell>
                <TableCell>
                  {Number(_get(details, 'score', 0)) * 100} %
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Text color="bodyLight">Status</Text>
                </TableCell>
                <TableCell>{_get(details, 'status', '–')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Text color="bodyLight">Liveliness</Text>
                </TableCell>
                <TableCell>
                  {details?.liveliness ? 'Yes' : 'No'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Text color="bodyLight">Verification ID</Text>
                </TableCell>
                <TableCell>
                  {_get(details, 'verification_id', '–')}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </AlertModal>
      );

    case MODAL_TYPES.FACE_NOT_DETECTED:
      return (
        <AlertModal
          type="success"
          title="Liveliness Check Successful."
          onClose={() => setModalType()}
        >
          Face is not Detected.
        </AlertModal>
      );

    case MODAL_TYPES.MULTIPLE_FACE_DETECTED:
      return (
        <AlertModal
          type="success"
          title="Liveliness Check is Invalid."
          onClose={() => setModalType()}
        >
          Multiple Face's Detected.
        </AlertModal>
      );
  }
};

Modals.propTypes = {
  modalType: PropTypes.string.isRequired,
  setModalType: PropTypes.func.isRequired,
};

export default Modals;
